import React from "react";

export default function App() {
	return (
		<>
		 <h2>Welcome, Guys!</h2>
			
			<p>
				If you ever had doubts such as, Do I even need to lose body fat? If yes, then how much to lose, how should I even start? What diet should I follow ? Do I need to go to the gym ?, or if you ever have encountered myths such as 'Rice makes us fat' then Congrats! You have successfully taken the first step towards Crushing your fitness goals and becoming your best self physically and mentally. You will get to know crisp and to the point information without any bullshit & myths. Most of the information in this guide is taken from current research and work of famous scientific people in the fitness industry, So yeah, you are pretty much getting state of the art information in this guide.
  
			</p>
			
			<p>
				One main reason behind creating this content is that there are a lot of myths out there when it comes to losing body fat/weight and also the fitness industry tends to make things quite complicated. 
				From my experience, however, I can say that it’s all very simple if you can just understand a few basics of fitness and nutrition. Consider this website as your friendly guide to waive all your doubts and fear about getting fit.
			</p> 
				
			<p>
				<strong>Before we get started, I suggest you try to forget all the crazy information you might have heard/read about exercise, dieting, etc. You must make room for the right information without letting the falsehoods of the fitness industry cloud your judgement.</strong>
			</p>
			
			<h4>How to use this Guide:</h4>
			<blockquote>
				<p>
					We’ve categorized the guide into following major sections:
					<ul className="task-list">
							<li>Basics Of Fat Loss</li>
							<li>Diet for Fat Loss</li>
							<li>Workout for Fat Loss</li>
							<li>Mistakes which hinders Progress</li>
							<li>Myths to avoid</li>
							
					</ul>
					Each section contains related factual information along with a practical example summary which helps you in making your decisions in an easier way.You can use a sidebar to navigate through the contents and read the website at your own pace. Try not to miss out any section as we’ve ensured that we’ve compiled only the essentials.
				</p>
			</blockquote>
			
			<p style={{marginLeft:60,fontSize:20}}>
				<strong>So Let's Begin Hustlers!!</strong>
			</p>
		</>
	);
}